__turbopack_context__.v({
  "link": "style-module-scss-module__SFPv7W__link",
  "links": "style-module-scss-module__SFPv7W__links",
  "links_extra": "style-module-scss-module__SFPv7W__links_extra",
  "links_main": "style-module-scss-module__SFPv7W__links_main",
});
